export default {
    getShopId: (item) => {
        return item["shop_id"]
    },
    getShopName: (item) => {
        return item["shop_name"]
    },
    getShopDescr: (item) => {
        return item["shop_descr"]
    },
    getImage: (item) => {
        if (item["shop_image_host"] === "" || item["shop_image_name"] === "") {
            return null
        }
        return {
            host: item["shop_image_host"],
            name: item["shop_image_name"],
        }
    },
    getSources: (item) => {
        return item["sources"]
    },
    getSourceId: (item) => {
        return item["source_id"]
    },
    getSourceName: (item) => {
        return item["source_name"]
    },
    getActive: (item) => {
        return !item["shop_delst"]
    },
    getIsPostExists: (item) => {
        return item["is_post_exists"]
    },
    getCampaigns: (item) => {
        return item["campaigns"]
    },
    getCampaignId: (item) => {
        return item["campaign_id"]
    },
    getCampaignName: (item) => {
        return item["campaign_name"]
    },
    getCntCouponParsed: (item) => {
        return item["cnt_coupon_parsed"]
    },
    getCntCouponNotParsed: (item) => {
        return item["cnt_coupon_not_parsed"]
    },
    getCntCouponPublished: (item) => {
        return item["cnt_coupon_published"]
    },
    getCntCouponCanceled: (item) => {
        return item["cnt_coupon_canceled"]
    },
    getCntCouponDelst: (item) => {
        return item["cnt_coupon_delst"]
    },
}
